import React from 'react';

// Update the component signature to make unused props optional
const VandalismForm = ({ formData = {}, onInputChange = () => {}, onFormSubmit, incidentId }) => {
  // Local state for this form's specific fields
  const [vandalismData, setVandalismData] = React.useState({
    damageType: '',
    estimatedCost: '',
    itemsDamaged: '',
    suspectedPerpetrator: '',
    reportedToPolice: 'No',
    policeReportNumber: ''
  });

  const [loading, setLoading] = React.useState(false);

  // Handle local form changes
  const handleLocalChange = (e) => {
    const { name, value } = e.target;
    setVandalismData({
      ...vandalismData,
      [name]: value
    });

    // Show police report number field only when reported to police
    if (name === 'reportedToPolice' && value === 'No') {
      setVandalismData(prevData => ({
        ...prevData,
        policeReportNumber: ''
      }));
    }
  };

  // Submit the form data to parent
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onFormSubmit(vandalismData, incidentId);
    setLoading(false);
  };
 
  return (
    <form onSubmit={handleSubmit}>
      <h3 className="text-lg font-medium mb-4">Vandalism Incident Details</h3>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">Type of Damage</label>
        <select
          name="damageType"
          value={vandalismData.damageType}
          onChange={handleLocalChange}
          className="w-full border rounded-md px-3 py-2"
          required
        >
          <option value="">Select damage type...</option>
          <option value="Graffiti">Graffiti</option>
          <option value="Property Damage">Property Damage</option>
          <option value="Equipment Damage">Equipment Damage</option>
          <option value="Vehicle Damage">Vehicle Damage</option>
          <option value="Theft">Theft</option>
          <option value="Other">Other</option>
        </select>
      </div>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">Items Damaged or Affected</label>
        <textarea
          name="itemsDamaged"
          value={vandalismData.itemsDamaged}
          onChange={handleLocalChange}
          className="w-full border rounded-md px-3 py-2 h-24"
          required
          placeholder="List all items that were damaged, defaced, or stolen"
        ></textarea>
      </div>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">Estimated Cost of Damage/Replacement ($)</label>
        <input
          type="number"
          name="estimatedCost"
          value={vandalismData.estimatedCost}
          onChange={handleLocalChange}
          className="w-full border rounded-md px-3 py-2"
          placeholder="0.00"
          min="0"
          step="0.01"
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">Suspected Perpetrator (if known)</label>
        <input
          type="text"
          name="suspectedPerpetrator"
          value={vandalismData.suspectedPerpetrator}
          onChange={handleLocalChange}
          className="w-full border rounded-md px-3 py-2"
          placeholder="Leave blank if unknown"
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">Was this incident reported to police?</label>
        <div className="flex gap-4">
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="reportedToPolice"
              value="Yes"
              checked={vandalismData.reportedToPolice === 'Yes'}
              onChange={handleLocalChange}
              className="mr-2"
            />
            Yes
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="reportedToPolice"
              value="No"
              checked={vandalismData.reportedToPolice === 'No'}
              onChange={handleLocalChange}
              className="mr-2"
            />
            No
          </label>
        </div>
      </div>
      
      {vandalismData.reportedToPolice === 'Yes' && (
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Police Report Number</label>
          <input
            type="text"
            name="policeReportNumber"
            value={vandalismData.policeReportNumber}
            onChange={handleLocalChange}
            className="w-full border rounded-md px-3 py-2"
            required
          />
        </div>
      )}
      
      <div className="flex justify-end">
        <button 
          type="submit" 
          disabled={loading}
          className={loading ? 'submit-button disabled' : 'submit-button'}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
      </div>
    </form>
  );
};

export default VandalismForm;